import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSubCategoryData, updateSubCategoryData } from "../../slices/panelSlice";
import Pagination from '../../components/Pagination';
import Loader from '../../components/Loader';
import EditableTable from "./VariableSubCategoryTable";
import Modal from "../../components/Modal"
import ChangeLog from "../../components/ChangeLog";
import Swal from "sweetalert2";
import { alertSuccess } from "../../components/Alert";
import api from "../../auth/api";


function VariableSubCategory({editable}) {
  const dispatch = useDispatch();
  const { subCategoryData, status, error } = useSelector((state) => state.panel);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(subCategoryData?.result) ? subCategoryData?.result?.slice(indexOfFirstItem, indexOfLastItem) : [];
  const totalPages = Array.isArray(subCategoryData?.result) ? Math.ceil(subCategoryData?.result?.length / itemsPerPage) : 0;
  const headers = subCategoryData?.result?.length > 0 ? Object.keys(subCategoryData.result[0]).filter((key) => key !== 'id') : [];
  const editableFields = ['title']; // Define editable fields

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog,setCurrentLog] = useState([]);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    dispatch(fetchSubCategoryData());
  }, [dispatch]);

  if (status === "loading") {
    return (
      <div className="pt-12">
        <Loader />
      </div>
    );
  }

  if (status === "failed") {
    return <div>Error: {error}</div>;
  }

  const addVariableSubCategory = () => {
    Swal.fire({
      title: "Add Variable Sub Category",
      input: "text",
      inputAttributes: {
        autocapitalize: "off"
      },
      showCancelButton: true,
      confirmButtonText: "Add",
      showLoaderOnConfirm: true,
      inputValidator: (value) => {
        if (!value) {
          return "Variable sub category is required!";
        }
        if (value.length < 3) {
          return "Variable sub category must be at least 3 characters long!";
        }
        if (!/^[a-zA-Z0-9\s]+$/.test(value)) {
          return "Variable sub category can only contain letters, numbers, and spaces!";
        }
        const isExist = subCategoryData?.result?.some(f=>f.title===value)
        if(isExist){
          return "This variable sub category is already exists."
        }

      },
      preConfirm: async (inpVal) => {
        try {
          const response = await api.post("/panel/SubCategory", { title: inpVal });
          alertSuccess("Variable Category added successfully.");
          dispatch(fetchSubCategoryData());
        } catch (error) {
          console.error(error);
          Swal.showValidationMessage(
            error.response?.data?.errors || error.message
          );
        }
      },
      allowOutsideClick:false
    });
  };

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = subCategoryData.result.find((user) => user.id === rowId);
    setEditedData(rowData);
  };


  const handleSave = async () => {
    const { id, title} = editedData;
    const updatedData = { id, title };
    console.log(updatedData)
    const resp = await dispatch(updateSubCategoryData(updatedData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchSubCategoryData());
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field,val) => {
      if(field==="active"){
        setEditedData((prev) => ({
          ...prev,
          [field]:!val,
        }));
      }else{
        setEditedData((prev) => ({
          ...prev,
          [field]:e.target.value,
        }));
      }
  };

  const handleLog = (id)=>{
    const logData = subCategoryData.Change_Log.filter((f)=>f.id===id)[0]?.oldTrack;
    setCurrentLog(logData)
    openModal()
  }

  return (
    <div className="w-full flex items-center flex-col">
      <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleChange={handleChange}
        handleLog={handleLog}
        editableFields={editableFields} // Pass editable fields
        editable={editable}
      />
  <div className="flex mt-4 items-center justify-between w-11/12">

<Pagination
  currentPage={currentPage}
  setCurrentPage={setCurrentPage}
  totalPages={totalPages}
/>

{editable && 
<button className="activeBtn text-sm text-white  py-1 px-2 rounded" onClick={addVariableSubCategory}>
      + Add Variable Sub Category
    </button>
}


    </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog}/>}
      />
    </div>
  );
}

export default VariableSubCategory